import { useMutation, useQueryClient } from '@tanstack/react-query';
import { inviteAdmin, inviteAdminInBulk } from 'api/admin.service';
import { clearPermissionStore, setErrorMessage } from 'store/permission';
import { PermissionFormData } from 'components/permissions/PermissionForm/PermissionForm.model';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';

export const useAdminCreateQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: ({ emails, role }: Omit<PermissionFormData, 'input'>) =>
      emails.length > 1
        ? inviteAdminInBulk(emails, role)
        : inviteAdmin(emails[0], role),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admins'] });
      clearPermissionStore();
      toast.success('Admin(s) have been invited successfully');
    },
    onError: (error: AxiosError) => {
      setErrorMessage(error.message);
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate };
};
